import React, { useState, FC } from 'react'
import { Row, Col, Tooltip, Label } from 'reactstrap'
import {FaInfoCircle} from 'react-icons/fa';
import {String, Utilities} from '@utils';

export interface AEAFieldLabelProps{
    id: string;
    title?: string;
    description?: string;   
    showTooltip?: boolean;
}

const AEAFieldLabel: FC<AEAFieldLabelProps> = (props: AEAFieldLabelProps) => {
    /* states */
    const [tooltipIsOpen, setTooltipIsOpen] = useState(false);

    /*attributes*/
    const tooltipId = `tooltip-${props.id}`;

    /*events*/
    const onToggleTooltip = () => {setTooltipIsOpen(!tooltipIsOpen)}
    //const toggle = () => setTooltipOpen(!tooltipOpen);
    /*renders*/
    const renderToolTip = () => {
        if(!String.IsNullOrWhiteSpace(props.description) && !Utilities.isNullObject(props.description)){
            return (
                <Tooltip
                    placement={"right"}
                    isOpen={tooltipIsOpen}
                    target={tooltipId}
                    toggle={onToggleTooltip}
                >{props.description} 
                </Tooltip>
            );
        }
        return <div></div>;
    }

    /*main render*/
    return (
        <Row>
            {props.showTooltip !== false ?
            <Col xs={1} md={2}>
                <FaInfoCircle id={`tooltip-${props.id}`}></FaInfoCircle>
                {renderToolTip()}
            </Col>
            :''}
            <Col>
                <Label for={props.id.toString()}>
                    {props.title}                    
                </Label>                
            </Col>
        </Row>
    )
}

export default AEAFieldLabel
